import Vue from "vue";
import Component from "vue-class-component";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "MyNotification" })
export default class MyNotification extends Vue {
    public localizer: any = Localizer;
    public isNotificationLoading: boolean = false;
    public notificationInterval: any = null;

    get notificationCount(): any {
        return this.$store.getters["myNotificationStore/notificationCount"];
    }

    get notificationViewForcedCount(): any {
        return this.$store.getters["myNotificationStore/notificationViewForcedCount"];
    }

    get notifications(): any {
        return this.$store.getters["myNotificationStore/notifications"];
    }

    public created() {
        this.getData();

        this.setNotificationInterval();
    }

    public async getData() {
        await this.getNotificationCount();

        if (this.notificationCount !== 0) {
            await this.getNotificationViewForcedCount();
        }
    }

    public async getNotificationCount() {
        await this.$store.dispatch("myNotificationStore/getNotificationCount");
    }

    public async getNotificationViewForcedCount() {
        await this.$store.dispatch("myNotificationStore/getNotificationViewForcedCount");

        if (this.notificationViewForcedCount !== 0) {
            await this.setNotificationList();

            (<any>this.$refs.notificationList).classList.add("show");
        }
    }

    public setNotificationInterval() {
        const interval = 30 * 1000; // 30 seconds
        let vm = this;
        this.notificationInterval = setInterval(function () {
            vm.getNotificationCount();
        }, interval);
    }

    public async setNotificationList() {
        this.isNotificationLoading = true;

        await this.$store.dispatch("myNotificationStore/getNotifications");

        this.isNotificationLoading = false;
    }

    public async notificationSetIsRead(notification: any) {
        await this.$store.dispatch("myNotificationStore/setIsRead", { notificationId: notification.id, isRead: true });

        let index: number = this.notifications.findIndex(x => x.id === notification.id);
        this.notifications.splice(index, 1);

        this.$store.commit("myNotificationStore/setNotificationCount", this.notifications.length);
    }

    public async notificationSetIsReadAll() {
        await this.$store.dispatch("myNotificationStore/setIsReadAll", {});

        this.setNotificationList();
    }

    public setNotificationType(notification: any) {
        switch (notification.type) {
            case "Info":
            default:
                return "app-mynotificationinfo";
            // default: return "app-appnotification-" + notification.type.toLowerCase();
        }
    }
};